/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./bridgeConfigField.vue?vue&type=template&id=3e0af36a&scoped=true&"
import script from "./bridgeConfigField.vue?vue&type=script&lang=js&"
export * from "./bridgeConfigField.vue?vue&type=script&lang=js&"
import style0 from "./bridgeConfigField.vue?vue&type=style&index=0&id=3e0af36a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e0af36a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VAutocomplete,VIcon,VSelect,VSwitch,VTextField,VTextarea})
